module.exports = __webpack_public_path__ + "static/media/gameplay_bg_01.c4867a3d.jpg";